import { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { toast } from '../../../../../../ui/toast';
import { getDashboardJobOpenings } from '../../../../../../utils/api_service/dashboard';
import { JobOpeningData } from '../../../../../../utils/types/DashboardTypes';

type TransformedJobOpening = {
  id: string;
  'Job Title': string;
  Applicants: number;
  Suitable: number;
  Outstanding: number;
  Shortlisted: number;
  Unsuccessful: number;
  'Start Date': string;
  'End Date': string;
};

export const useJobOpeningTab = (externalSearchTerm?: string) => {
  const history = useHistory();
  const [pageNumber, setPageNumber] = useState<number>(1);
  const [totalPages, setTotalPages] = useState<number>(1);
  const [loading, setLoading] = useState<boolean>(false);
  const [jobOpeningData, setJobOpeningData] = useState<TransformedJobOpening[]>(
    [],
  );
  const [totalRecords, setTotalRecords] = useState(0);

  const fetchUsers = async (page: number) => {
    setLoading(true);
    try {
      const response = await getDashboardJobOpenings(
        externalSearchTerm ?? '',
        page,
      );
      if (!response.ok) {
        throw new Error('Failed to fetch job openings');
      }
      const data = await response.json();

      // Transform the data to use the required titles
      const transformedData: TransformedJobOpening[] = data.jobOpenings.map(
        (job: JobOpeningData) => ({
          id: job.id,
          'Job Title': job.jobTitle,
          Applicants: job.applicants,
          Suitable: job.suitable,
          Outstanding: job.outstanding,
          Shortlisted: job.shortlisted,
          Unsuccessful: job.unsuccessful,
          'Start Date': job.startDate,
          'End Date': job.endDate,
          'Job Reference': job.job_reference,
        }),
      );

      setTotalPages(Math.ceil(data.total / 5));
      setJobOpeningData(transformedData);
      setTotalRecords(data.total);
    } catch (error) {
      toast.error('Error Fetching Job Opening Data', {
        position: 'bottom-center',
      });
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    const debounceSearch = setTimeout(() => {
      fetchUsers(pageNumber);
    }, 1000);

    return () => clearTimeout(debounceSearch);
  }, [externalSearchTerm, pageNumber]);

  const onPageChange = (page: number) => {
    setPageNumber(page);
  };

  return {
    searchTerm: externalSearchTerm,
    jobOpeningData,
    pageNumber,
    totalPages,
    loading,
    setJobOpeningData,
    onPageChange,
    history,
    totalRecords,
  };
};
